import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { CustomerList } from "./customerList"
import { AllCustomersList } from "./list"

export function Segnalazioni() {
    const navigate = useNavigate()
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const sessionState = useAppSelector(state => state.session)

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'Segnalazioni']}
            noPaddingLat
            headerLabel="Segnalazioni"
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    {
                        (sessionState.selected.customerId) &&
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Crea nuovo"
                            color={"orange"}
                            onClick={() => {
                                navigate('/addSegnalazione')
                            }}
                        />
                    }
                </div>
            }
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Elenco cliente</div>
                <div>Elenco completo</div>
            </CustomHorizontalTab>
            <div className="fieldset bg-brandPrimary-200">
                {
                    selectedTab === 0 &&
                    <CustomerList />
                }
                {
                    selectedTab === 1 &&
                    <AllCustomersList />
                }
            </div>
        </Layout>
    )
}